// src/adminDashboard/shared/components/SkipLink.tsx
// Skip to main content link for keyboard navigation

import React from 'react';

interface SkipLinkProps {
    targetId?: string;
    children?: React.ReactNode;
}

const SkipLink: React.FC<SkipLinkProps> = ({ targetId = 'main-content', children = 'Skip to main content' }) => {
    return (
        <a
            href={`#${targetId}`}
            className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-white focus:rounded-lg focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
        >
            {children}
        </a>
    );
};

export default SkipLink;
